module.exports = __webpack_public_path__ + "img/nakladki-progowe-stal-nierdzewna.6c062483.jpg";